var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMyOrdersHovered = function SvgMyOrdersHovered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.321a1.5 1.5 0 0 1 1.5-1.5h18a1.5 1.5 0 0 1 1.5 1.5v3.092h-21V3.321Z",
    fill: "#fff",
    stroke: "#069BAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.7h21V19a3.5 3.5 0 0 1-3.5 3.5H5A3.5 3.5 0 0 1 1.5 19V4.7Z",
    fill: "#fff",
    stroke: "#069BAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.833 1.5a.413.413 0 0 1 .413.417v5.278a.038.038 0 0 1-.023.036l-.01.004a.013.013 0 0 1-.007.001l-.076.494.076-.494a.013.013 0 0 1-.006-.003l-.006-.005-1.726-1.53-.01-.008-.01-.008a.723.723 0 0 0-.9 0l-.01.008-.01.009-1.726 1.529-.009.008-.003.001.077.495-.077-.495h-.004l-.006-.003-.007-.003a.039.039 0 0 1-.023-.036V1.917a.413.413 0 0 1 .404-.417h3.679Zm-4.583.422v5.27a.539.539 0 0 0 .323.497L9.25 1.922Z",
    fill: "#fff",
    stroke: "#069BAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#069BAA",
    strokeLinecap: "round",
    d: "M4.5 11.5h7M4.5 14.5h4"
  })));
};
export default SvgMyOrdersHovered;